const PROD_API = 'https://api.gowele.com/api';

const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:5000/api';
  return process.env.REACT_APP_API_URL || PROD_API;
};

export const API_URL = getApiUrl();
